module.exports = __webpack_public_path__ + "img/list employee manage active.831a903a.svg";